export default __webpack_public_path__ + "static/media/fight.f4e83f47.svg";